module.exports = __webpack_public_path__ + "img/quotation.a12f90a6.svg";